module.exports = __webpack_public_path__ + "img/post2.91f4bae7.png";